const without59 = [
  { value: 1, label: "D1" },
  { value: 2, label: "D2" },
  { value: 3, label: "D3" },
  { value: 4, label: "D4" },
  { value: 5, label: "D5" },
  { value: 6, label: "D6" },
  { value: 7, label: "D7" },
  { value: 8, label: "D8" },
  { value: 9, label: "D9" },
  { value: 10, label: "D10" },
  { value: 11, label: "D11" },
  { value: 12, label: "D12" }
];

const with59 = [...without59, { value: 59, label: "D59" }];

const distOptions = {
  without59,
  with59
};

export default distOptions;
